import { render } from "./CookiesDescriptionBox.vue?vue&type=template&id=46194d72&scoped=true&ts=true"
import script from "./CookiesDescriptionBox.vue?vue&type=script&lang=ts"
export * from "./CookiesDescriptionBox.vue?vue&type=script&lang=ts"

import "./CookiesDescriptionBox.vue?vue&type=style&index=0&id=46194d72&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46194d72"]])

export default __exports__